import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CalendarDayComponent } from './day.component';
import { CalendarsService } from '../../services/calendar.service';
import { DisclaimerModule } from '@finder/shared/components/disclaimer/disclaimer.module';
import { AnchorModule } from '@finder/shared/components/anchor/anchor.module';
import { ButtonModule } from '@finder/shared/components/button/button.module';
import { ParkCardComponent } from './components/park-card/park-card.component';
import { ParkSectionComponent } from './components/park-section/park-section.component';
import { FontIconModule } from '@finder/shared/components/font-icon/font-icon.module';
import { LoadingSpinnerModule } from '@finder/shared/components/loading-spinner/loading-spinner.module';
import { ScheduleTimeModule } from '@finder/shared/components/schedule-time/schedule-time.module';
import { SectionModule } from '@finder/shared/components/section/section.module';

const exportableComponents = [
    ParkCardComponent,
    ParkSectionComponent,
    CalendarDayComponent
];

const exportableModules = [
    DisclaimerModule,
    AnchorModule,
    ButtonModule,
    FontIconModule,
    LoadingSpinnerModule,
    ScheduleTimeModule,
    SectionModule,
];

@NgModule({
    imports: [
        CommonModule,
        ...exportableModules,
    ],
    declarations: [
        exportableComponents,
    ],
    providers: [
        CalendarsService,
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
})
export class CalendarsDayModule { }
